module.exports = __webpack_public_path__ + "img/saru.5061ee2d.jpg";